import React from "react";
import {autobind} from "core-decorators";
import {inject, observer} from "mobx-react";
import {Link, Redirect, RouteComponentProps} from "react-router-dom";
import {Button, message, Typography} from "antd";

import "./SignUp.scss";
import {paths} from "@/routes";
import {ILocationStateReferrerProps} from "@/routes/Routes";
import {signUp} from "@/lib/backend";
import logo from "@/assets/logo.svg";
import SignUpForm from "./SignUpForm";
import Store from "@/stores";

// https://www.pluralsight.com/guides/react-router-typescript
export interface ISignUpProps extends RouteComponentProps<{}, {}, ILocationStateReferrerProps> {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class SignUp extends React.Component<ISignUpProps, any> {
  // Referrer location (it has been set in routes/Routes)
  get referrerLocation() {
    return this.props.location.state?.referrer || {pathname: paths.home()};
  }

  async onSubmitSignUpForm({name, email, password}: {name: string; email: string; password: string}) {
    const {history} = this.props.store!;
    try {
      const confirmSuccessUrl = `${window.location.origin}${paths.signIn()}`;
      await signUp({name, email, password, confirmSuccessUrl});
      history.history.push(paths.signUpSuccess());
    } catch (error) {
      console.error(error);
      message.error(error?.message || error?.data?.message || "Oops! Something went wrong");
    }
  }

  public render() {
    const store = this.props.store!;
    if (store.session.isSignedIn) return <Redirect to={this.referrerLocation} />;
    return (
      <div className="SignUp">
        <img className="Logo" src={logo} alt="Logo" />
        <SignUpForm onSubmit={this.onSubmitSignUpForm} />
        <Typography.Paragraph style={{marginBottom: 5}}>Already have an account?</Typography.Paragraph>
        <Link to={paths.signIn()}>
          <Button type="default">Sign in</Button>
        </Link>
      </div>
    );
  }
}
